<template>
  <el-container style="height:100vh;align-items:center;justify-content:center;">
    <el-card style="width:360px;margin:0 auto;">
      <h3 style="text-align:center">管理后台登录</h3>
      <el-form :model="form" label-position="top">
        <el-form-item label="用户名">
          <el-input v-model="form.username" autocomplete="username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.password" type="password" autocomplete="current-password" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" block @click="onLogin" :loading="loading">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </el-container>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { auth } from '../api'
import { ElMessage } from 'element-plus'

export default {
  setup () {
    const form = ref({ username: '', password: '' })
    const loading = ref(false)

    const router = useRouter()

    const onLogin = async () => {
      loading.value = true
      try {
        const res = await auth.login(form.value.username, form.value.password)
        // server returns { code: 200, data: { token, admin } }
        const body = res.data || {}
        if (body.code !== 200) throw new Error(body.message || '登录失败')
        const token = body.data?.token || ''
        const admin = body.data?.admin || null
        if (!token) throw new Error('未返回 token')
        localStorage.setItem('admin_token', token)
        if (admin) localStorage.setItem('admin_info', JSON.stringify(admin))
        ElMessage.success('登录成功')
        router.push('/')
      } catch (err) {
        console.error(err)
        ElMessage.error(err?.response?.data?.message || '登录失败')
      } finally {
        loading.value = false
      }
    }

    return { form, loading, onLogin }
  }
}
</script>
